var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer flex align-center justify-space-between",class:{'above':_vm.position === 'above'}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v(" Diseñado y desarrollado por "),_c('a',{attrs:{"href":"https://aplicacionesexcel.com/","target":"_blank"}},[_vm._v("AplexTM")])])])
}]

export { render, staticRenderFns }